"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCountdown = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var initialValues = {
  days: '00',
  hours: '00',
  minutes: '00',
  seconds: '00',
  timeRemaining: 0
};

var useCountdown = function useCountdown(_ref) {
  var dueDate = _ref.dueDate;

  var _useState = (0, _react.useState)(initialValues.days),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      days = _useState2[0],
      setDays = _useState2[1];

  var _useState3 = (0, _react.useState)(initialValues.hours),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      hours = _useState4[0],
      setHours = _useState4[1];

  var _useState5 = (0, _react.useState)(initialValues.minutes),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      minutes = _useState6[0],
      setMinutes = _useState6[1];

  var _useState7 = (0, _react.useState)(initialValues.seconds),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      seconds = _useState8[0],
      setSeconds = _useState8[1];

  var _useState9 = (0, _react.useState)(),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      timeRemaining = _useState10[0],
      setTimeRemaining = _useState10[1];

  var padNumber = function padNumber(number) {
    return number < 10 ? "0".concat(number) : number;
  };

  var setInitialTime = function setInitialTime() {
    setDays(initialValues.days);
    setHours(initialValues.hours);
    setMinutes(initialValues.minutes);
    setSeconds(initialValues.seconds);
    setTimeRemaining(initialValues.timeRemaining);
  };

  var updateTime = function updateTime(time) {
    if (typeof time !== 'number' || time < 0) {
      setInitialTime(0);
      return;
    }

    var daysAux = Math.floor(time / 86400);
    setDays(padNumber(daysAux));
    var remainingDays = time - daysAux * 86400;
    var hoursAux = padNumber(Math.floor(remainingDays / 3600));
    setHours(hoursAux);
    var remainingHours = remainingDays - hoursAux * 3600;
    var minutesAux = padNumber(Math.floor(remainingHours / 60));
    setMinutes(minutesAux);
    var remainingMinutes = remainingHours - minutesAux * 60;
    setSeconds(padNumber(Math.floor(remainingMinutes)));
    setTimeRemaining(time);
  };

  (0, _react.useEffect)(function () {
    var timeInterval;

    if (dueDate) {
      var now = new Date().getTime();
      var dueTimeDate = new Date(dueDate);
      var timeDiff = parseInt((dueTimeDate - now) / 1000, 10);
      updateTime(timeDiff);

      if (timeDiff > 0) {
        timeInterval = setInterval(function () {
          timeDiff -= 1;
          updateTime(timeDiff);

          if (timeDiff === 0) {
            clearInterval(timeInterval);
          }
        }, 1000);
      }
    }

    return function () {
      if (timeInterval) {
        clearInterval(timeInterval);
      }
    };
  }, [dueDate]);
  return {
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds,
    timeRemaining: timeRemaining
  };
};

exports.useCountdown = useCountdown;